{
	"page": {
		"title": "User Groups",
		"count_one": "{{n}} group",
		"count_other": "{{n}} groups",
		"intro": "A <strong>user group</strong> decides what its members may do as Operation or Organization: <strong>where</strong> (organizations, functions, games), <strong>what</strong> (permissions) and, for operators, <strong>which sports</strong>. Each login belongs to at most one group.",
		"addGroup": "Add group"
	},
	"roleHint": {
		"OPERATION": "Host operations — may approve, and may hold sports",
		"ORGANIZATION": "A participating organization or NOC — registers and submits, never approves",
		"TRANSPORT_PROVIDER": "A transport company — sees only its own vehicles, drivers and the trips on them, never accreditation records",
		"HOTEL": "A hotel or village front desk — sees only the guests of its own buildings, never accreditation records"
	},
	"filters": {
		"searchLabel": "Group name",
		"button": "Filters",
		"sheetTitle": "Filter groups",
		"roleLabel": "Role",
		"allRoles": "All roles",
		"statusLabel": "Status",
		"anyStatus": "Any status",
		"active": "Active",
		"inactive": "Inactive"
	},
	"table": {
		"name": "Group",
		"role": "Role",
		"status": "Status",
		"members": "Members",
		"membersTitle": "Logins in this group",
		"scopes": "Scope rows",
		"scopesTitle": "Where this group may act",
		"permissions": "Permissions",
		"permissionsTitle": "What this group may do",
		"sports": "Sports",
		"sportsTitle": "Sports this group may write (Operation groups only)",
		"updated": "Updated",
		"active": "Active",
		"inactive": "Inactive",
		"viewLabel": "Open {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} group",
		"summary_other": "{{from}}–{{to}} of {{total}} groups",
		"empty": "No groups"
	},
	"empty": {
		"filteredTitle": "No groups match these filters",
		"filteredDescription": "Try another name, or clear the filters.",
		"noneTitle": "No user groups yet",
		"noneDescription": "Operation and Organization logins see nothing until they are in a group. Add the first one.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add user group",
		"addDescription": "Create the group first; you choose where it applies, its permissions and its sports on the next page.",
		"editTitle": "Edit {{name}}",
		"editDescription": "The role cannot change. A group for the other role is a new group.",
		"section": {
			"identity": "Identity",
			"identityHint": "How admins find this group.",
			"role": "Role",
			"roleHint": "Fixed once the group is created."
		},
		"field": {
			"name": "Name",
			"description": "Description",
			"role": "Role",
			"roleFixed": "The role is fixed after creation: the group applies only to logins acting as this role.",
			"isActive": "Active",
			"isActiveHint": "An inactive group grants nothing to its members."
		},
		"placeholder": {
			"name": "e.g. NOC Thailand",
			"description": "Who is in it and why"
		},
		"addSubmit": "Add group",
		"saveChanges": "Save changes"
	},
	"toast": {
		"added": "Added “{{name}}”",
		"addFailed": "Couldn't add group",
		"updated": "Saved “{{name}}”",
		"updateFailed": "Couldn't save group",
		"activated": "“{{name}}” is active",
		"deactivated": "“{{name}}” is inactive — its members now get nothing from it",
		"statusFailed": "Couldn't change status"
	},
	"errors": {
		"nameTaken": "A group with this name already exists",
		"invalidValue": "Invalid value",
		"hasMembers": "This group still has members. Move them to another group, or take them out, before deleting it."
	},
	"delete": {
		"title": "Delete user group",
		"description": "Delete <strong>{{name}}</strong>? Its scope rows, permissions and sports go with it. This only works while it has no members.",
		"confirm": "Delete group",
		"deleted": "Deleted “{{name}}”",
		"failed": "Couldn't delete group",
		"disabledTitle": "Take every member out of the group first"
	},
	"detail": {
		"back": "User groups",
		"subtitle": "{{role}} user group",
		"loadFailedTitle": "Couldn't load this group",
		"noDescription": "No description",
		"edit": "Edit",
		"delete": "Delete",
		"readOnly": "Only a Super Admin can change user groups.",
		"summary": {
			"title": "Summary",
			"role": "Role",
			"roleFixed": "Fixed. Applies only while a member acts as {{role}}.",
			"status": "Status",
			"members": "Members",
			"createdOn": "Created {{stamp}}",
			"updated": "Updated",
			"inactiveNote": "Inactive: members get nothing from this group until it is active again."
		},
		"deactivate": {
			"title": "Deactivate group",
			"body_one": "<strong>{{name}}</strong> has {{count}} member. While the group is inactive they see nothing and can do nothing as {{role}}.",
			"body_other": "<strong>{{name}}</strong> has {{count}} members. While the group is inactive they see nothing and can do nothing as {{role}}.",
			"confirm": "Deactivate"
		}
	},
	"scopes": {
		"title": "Where",
		"intro": "Each row is a place this group may act. A column left on <em>Any</em> stays open; rows add up. Without <strong>Can register</strong>, a row only lets members see.",
		"empty": "<strong>No scope rows.</strong> Members of this group see <em>nothing</em> until a row is added.",
		"dimensions": {
			"organization": "Organization",
			"mainFunction": "Main function",
			"subAgency": "Sub-agency",
			"subFunction": "Sub-function",
			"games": "Games",
			"canWrite": "Can register"
		},
		"any": "any",
		"anyTitle": "{{label}}: any",
		"bothGames": "Both games",
		"canWrite": "Can register",
		"readOnly": "View only",
		"edit": "Edit rows",
		"editor": {
			"addRow": "Add row",
			"save": "Save rows",
			"cancel": "Cancel",
			"confirmNone": "Save with no rows? Members will see nothing.",
			"confirm": "Save anyway",
			"loading": "Loading organizations, functions and games…",
			"duplicates": "Two rows say the same thing — remove one.",
			"blankIgnored": "Rows with nothing picked are ignored.",
			"incomplete": "A row needs at least one of organization, main function, sub-agency or sub-function — games alone is not a scope.",
			"applyNote": "Changes apply to every member on their next request — no sign-out needed.",
			"anyPlaceholder": "Any",
			"bothGamesPlaceholder": "Both games",
			"canWriteLabel": "Can register in row {{row}}",
			"cellAria": "{{label}}, row {{row}}",
			"removeRowAria": "Remove row {{row}}",
			"removeRow": "Remove row",
			"noSubFunctions": "No sub-functions under that main function",
			"otherGroup": "Other"
		},
		"saved_one": "Saved {{count}} scope row",
		"saved_other": "Saved {{count}} scope rows",
		"cleared": "Scope cleared — members now see nothing",
		"saveFailed": "Couldn't save scope rows"
	},
	"permissions": {
		"title": "What",
		"intro": "What members may do inside the group's scope. Only permissions this group's role ({{role}}) may hold can be ticked.",
		"organizationNote": "Organization groups can register, submit and invite, but can never approve. Approval is always done by the host's Operation groups.",
		"notForRole": "{{roles}} groups only",
		"notForRoleTitle": "{{role}} groups cannot hold this permission",
		"none": "No permissions yet — members can see their scope but cannot change anything.",
		"save": "Save permissions",
		"reset": "Undo changes",
		"saved": "Permissions saved",
		"saveFailed": "Couldn't save permissions",
		"area": {
			"accreditation": "Accreditation",
			"card": "E-Accreditation",
			"competition": "Competition",
			"logistics": "Logistics",
			"transport": "Transport",
			"accommodation": "Accommodation",
			"helpdesk": "Helpdesk",
			"fnb": "Food & Beverages"
		},
		"catalogue": {
			"accreditation": {
				"register": {
					"label": "Register people",
					"description": "Add and edit people and their accreditation records inside the group's scope."
				},
				"submit": {
					"label": "Submit for approval",
					"description": "Send registered records to the host for approval."
				},
				"approve": {
					"label": "Approve accreditation",
					"description": "Approve or reject submitted accreditation records. Host side only."
				},
				"invite": {
					"label": "Send invitations",
					"description": "Send personal QR invitations so people can register themselves."
				},
				"health": {
					"label": "Read medical documents",
					"description": "Open medical certificates and anti-doping TUEs of records in scope. Host side only."
				}
			},
			"card": {
				"print": {
					"label": "Print cards",
					"description": "Make print batches of approved cards in the group's scope and mark them printed. Host side only."
				},
				"activate": {
					"label": "Activate cards",
					"description": "Activate printed cards in the group's scope, valid until a chosen date. Host side only."
				},
				"report_lost": {
					"label": "Report lost cards",
					"description": "Report a card in the group's scope lost, stolen or damaged, and undo the report within a few minutes."
				}
			},
			"competition": {
				"entries": {
					"label": "Manage entries",
					"description": "Enter competitors into the events of the group's sports."
				},
				"results": {
					"label": "Enter results",
					"description": "Record results for the group's sports."
				},
				"official": {
					"label": "Make results official",
					"description": "Confirm results of the group's sports as official."
				},
				"shortlist": {
					"label": "Shortlist athletes",
					"description": "Pick athletes per event as primary or reserve for the organizations in scope, and submit each sport's shortlist as final."
				},
				"declare": {
					"label": "Declare sport entries",
					"description": "Fill in the expression of interest and entry by number (sports, events and numbers) for the organizations in scope, and submit them."
				},
				"display": {
					"label": "Control venue displays",
					"description": "Drive the venue display screens and scoreboards of the group's sports in TSR. Does not enter results."
				}
			},
			"logistics": {
				"travel": {
					"label": "Manage travel",
					"description": "Add and change arrival and departure details of records in the group's scope, also after approval."
				},
				"travel_review": {
					"label": "Arrival & departure desk",
					"description": "See all travel in scope, update flight times and set delays. Host side only."
				}
			},
			"transport": {
				"request": {
					"label": "Request trips",
					"description": "Request venue trips for the organizations in scope and follow their transfers. Organization groups must book ahead (the lead time in the transport settings)."
				},
				"dispatch": {
					"label": "Transport desk",
					"description": "Operation: turn arrivals into transfers, assign vehicles and drivers, and run the fleet. Transport provider: start and finish the trips on the company's own vehicles."
				}
			},
			"accommodation": {
				"manage": {
					"label": "Accommodation office",
					"description": "Set up buildings and rooms, reserve rooms for contingents, assign beds and confirm suggested rooms for records in the group's scope. Host side only."
				},
				"desk": {
					"label": "Front desk",
					"description": "Operation: check guests in and out for records in scope. Hotel: check in and out the guests of the group's own buildings."
				}
			},
			"helpdesk": {
				"handle": {
					"label": "Work helpdesk tickets",
					"description": "Take, update and resolve tickets. Operation: tickets of the organizations in scope. Hotel: tickets about the group's own buildings."
				},
				"report": {
					"label": "Report problems",
					"description": "Report a problem with a room where the group's own people stay, and follow its organization's tickets."
				}
			},
			"fnb": {
				"order": {
					"label": "Order packed meals",
					"description": "Order packed (takeaway) meals for the organizations in scope and follow them. Organization groups can cancel until the meal starts."
				},
				"manage": {
					"label": "F&B desk",
					"description": "Set up dining halls and F&B settings, see the meal plan, and confirm, reject or hand out packed-meal orders for the organizations in scope. Host side only."
				},
				"scan": {
					"label": "Scan meal passes",
					"description": "Scan accreditation cards at a dining hall's door: one meal per person per session. Host side only."
				}
			}
		}
	},
	"sports": {
		"title": "Sports",
		"intro": "The sports whose entries and results members may write. Competition permissions only apply to these.",
		"none": "No sports yet — competition permissions do nothing until a sport is added.",
		"edit": "Edit sports",
		"pickLabel": "Sports",
		"placeholder": "Pick sports",
		"loading": "Loading sports…",
		"save": "Save sports",
		"cancel": "Cancel",
		"saved_one": "Saved {{count}} sport",
		"saved_other": "Saved {{count}} sports",
		"cleared": "Sports cleared",
		"saveFailed": "Couldn't save sports"
	},
	"facilities": {
		"title": "Transport companies",
		"intro": "A transport provider group sees only the vehicles, drivers and trips of the companies listed here. It never sees accreditation records, and holds no scope rows or sports.",
		"empty": "<strong>No company yet.</strong> Members of this group see <em>nothing</em> until one is added.",
		"edit": "Edit companies",
		"pickLabel": "Transport companies",
		"placeholder": "Pick a transport company",
		"loading": "Loading transport companies…",
		"save": "Save companies",
		"cancel": "Cancel",
		"removeAria": "Remove {{name}}",
		"confirmNone": "Save with no company? Members will see nothing.",
		"saved_one": "Saved {{count}} company",
		"saved_other": "Saved {{count}} companies",
		"cleared": "Companies cleared — members now see nothing",
		"saveFailed": "Couldn't save companies",
		"validation": {
			"required": "Pick a transport company",
			"max": "At most {{max}} companies per group",
			"duplicate": "This transport company is listed twice"
		}
	},
	"facilitiesLodging": {
		"title": "Hotels",
		"intro": "A hotel group sees only the guests of the buildings listed here. It never sees accreditation records, and holds no scope rows or sports.",
		"empty": "<strong>No building yet.</strong> Members of this group see <em>nothing</em> until one is added.",
		"edit": "Edit buildings",
		"pickLabel": "Buildings",
		"placeholder": "Pick a building",
		"loading": "Loading buildings…",
		"save": "Save buildings",
		"cancel": "Cancel",
		"removeAria": "Remove {{name}}",
		"confirmNone": "Save with no building? Members will see nothing.",
		"saved_one": "Saved {{count}} building",
		"saved_other": "Saved {{count}} buildings",
		"cleared": "Buildings cleared — members now see nothing",
		"saveFailed": "Couldn't save buildings",
		"validation": {
			"required": "Pick a building",
			"max": "At most {{max}} buildings per group",
			"duplicate": "This building is listed twice"
		}
	},
	"members": {
		"title": "Members",
		"intro": "Logins in this group. Move a login in or out from its user page.",
		"searchLabel": "Name, Username or Email",
		"user": "User",
		"roles": "Roles",
		"status": "Status",
		"lastSignIn": "Last sign-in",
		"never": "Never",
		"viewLabel": "View {{name}}",
		"summary_one": "{{from}}–{{to}} of {{total}} member",
		"summary_other": "{{from}}–{{to}} of {{total}} members",
		"empty": "No members",
		"noneTitle": "No members yet",
		"noneDescription": "Open a user's page and choose this group in its User group card.",
		"filteredTitle": "No members match",
		"filteredDescription": "Try another search, or clear it.",
		"clearFilters": "Clear search"
	},
	"modules": {
		"title": "Modules",
		"intro": "Every permission a user group can hold, and which group roles may hold it. Permissions are granted to groups on each group's page — this list is for reference.",
		"permission": "Permission",
		"code": "Code",
		"area": "Area",
		"description": "What it allows",
		"roles": "Group roles",
		"summary_one": "{{total}} permission",
		"summary_other": "{{total}} permissions"
	}
}
